import _ from "lodash";
import axios from "axios";
import { canaveral_url } from ".";

// ========================== HOTELS =============================
export const fetchHotelReservations = ({ external_creator }) => {
  return axios.get(`${canaveral_url}/reservations/accommodation/`, {
    params: { external_creator },
  });
};

export const fetchHotelReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/accommodation/${reservationRefId}/`
  );
};

// ========================== FLIGHTS ============================
export const fetchFlightsReservations = ({ external_creator }) => {
  return axios.get(`${canaveral_url}/reservations/flights/`, {
    params: { external_creator },
  });
};

export const fetchFlightReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/flights/${reservationRefId}/`
  );
};

// ========================== TRANSFERS ==========================
export const fetchTransfersReservations = ({ external_creator }) => {
  return axios.get(`${canaveral_url}/reservations/transfers/`, {
    params: { external_creator },
  });
};

export const fetchTransferReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/transfers/${reservationRefId}/`
  );
};

// ========================== ACTIVITIES =========================
export const fetchActivitiesReservations = ({ external_creator }) => {
  return axios.get(`${canaveral_url}/reservations/activities/`, {
    params: { external_creator },
  });
};

export const fetchActivityReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/activities/${reservationRefId}/`
  );
};

// ========================== ADDONS =============================
export function fetchAddonsReservations({ external_creator }) {
  return axios.get(`${canaveral_url}/reservations/addons`, {
    params: { external_creator },
  });
}

export const fetchAddonReservationDetails = ({ reservationRefId }) => {
  return axios.get(`${canaveral_url}/reservations/addons/${reservationRefId}/`);
};

// ========================== FERRIES =============================
export function fetchFerryReservations({ external_creator }) {
  return axios.get(`${canaveral_url}/reservations/api-ferry`, {
    params: { external_creator },
  });
}

export const fetchFerryReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/api-ferry/${reservationRefId}/`
  );
};

// ========================== TRAINS =============================
export function fetchTrainReservations({ external_creator }) {
  return axios.get(`${canaveral_url}/reservations/api-trains`, {
    params: { external_creator },
  });
}

export const fetchTrainReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/api-trains/${reservationRefId}/`
  );
};

// ========================== CARS =============================
export function fetchCarRentalReservations({ external_creator }) {
  return axios.get(`${canaveral_url}/reservations/car-rental`, {
    params: { external_creator },
  });
}

export const fetchCarRentalReservationDetails = ({ reservationRefId }) => {
  return axios.get(
    `${canaveral_url}/reservations/car-rental/${reservationRefId}/`
  );
};

// =================== SEND RESERVATION EMAIL ====================
export const sendReservationEmail = async (payload) => {
  try {
    const response = await axios.post(
      `${canaveral_url}/reservations/send-email`,
      payload
    );
    return _.get(response, "", {});
  } catch (error) {
    console.error(error);
  }
  return null;
};
